import React, { memo } from 'react'
import { Grid2 } from '@mui/material'

import PageTitle from '../shared/pageTitle/PageTitle'
import HowToPlay from './HowToPlay'
import Prizes from './Prizes'
import ScratchCard from './ScratchCard'

const Games = ({
  t,
  symbol,
  onOpenScratchCard,
  gameProfile,
  onCompleteScratch,
  currentUserPoints
}) => {
  const pageTitle = t('game.scratch-cards')
  return (
    <>
      <PageTitle
        title={pageTitle}
        desc={t('game.scratch-cards-desc', { symbol })}
      />
      <Grid2 container spacing={3}>
        <Grid2 size={{ xs: 12, md: 4 }} order={{ xs: 3, sm: 1, md: 1 }}>
          <HowToPlay t={t} symbol={symbol} />
        </Grid2>
        <Grid2 size={{ xs: 12, md: 4 }} order={{ xs: 1, sm: 2, md: 2 }}>
          <ScratchCard
            t={t}
            onOpenScratchCard={onOpenScratchCard}
            gameProfile={gameProfile}
            onCompleteScratch={onCompleteScratch}
            symbol={symbol}
            currentUserPoints={currentUserPoints}
          />
        </Grid2>
        <Grid2 size={{ xs: 12, md: 4 }} order={{ xs: 2, sm: 3, md: 3 }}>
          <Prizes t={t} symbol={symbol} />
        </Grid2>
      </Grid2>
    </>
  )
}

export default memo(Games)
